import axios from '@/axios/config'

export default {
  namespaced: true,
  state: {
    regions: [],
  },
  mutations: {
    updateRegions(state, payload) {
      state.regions = payload
    },
  },
  actions: {
    async getRegions({ commit }, { include_counts = false } = {}) {
      const { data } = await axios.get('/api/region', {
        params: { include_counts },
      })
      commit('updateRegions', data)
      return data
    },
    async deleteRegion({ dispatch }, { id }) {
      await axios.delete(`/api/region/${id}`)
      dispatch('getRegions', { include_counts: true })
    },
    async createRegion({ dispatch }, data) {
      await axios.post('/api/region', data)
      dispatch('getRegions', { include_counts: true })
    },
    async updateRegion({ dispatch }, { id, ...data }) {
      await axios.put(`/api/region/${id}`, data)
      dispatch('getRegions', { include_counts: true })
      dispatch('getListingsPicker', null, { root: true })
    },
  },
}
